
import axios from 'axios';
import { BASE_URL } from './app.constant';

const instance = axios.create({
  baseURL: BASE_URL,
});

// Add a request interceptor to attach Bearer token except for /auth/login
instance.interceptors.request.use(
  (config) => {
    // Do not attach token for login route
    if (!config.url.endsWith('/auth/login')) {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default instance;